import { ProgramHeader } from '~widgets/header/components/program-header'
import { IntroSection } from './intro-section'
import { TProgramPageProps } from '@/modules/program-page/fractals'
import { CourseReasons } from './course-reasons'
import { FaqSection } from '~widgets/faq/components/faq-section'
import { LeadForm1Section, LeadForm2Section } from './lead-form-section'
import { TeachersSection } from './teachers-section'
import { Footer } from '~widgets/footer/components/footer'
import { WhyUsSection } from './why-us-section'
import { EmploymentHelp } from './employment-help'
import { CourseOutComeSection } from './course-outcome'
import { OneCourseTwoDiplomasSection } from './one-course-two-doplomas'
import { AboutCourseSection } from './about-course'

export const PsychologyProgramPage = ({
  hero,
  diplomas,
  whatWillYouLearn,
  accentColor,
  graduateProfessions,
  leastProgramContents,
  fullProgramContents,
  questions,
  cost,
  studySteps,
  reviews,
  teachers,
  forWhom,
  studyIs,
  examFreeEnrollment,
  footer,
  seo,
  howTrainingWorksCards
}: TProgramPageProps) => {
  return (
    <div className='box-border leading-[1.2]'>
      <ProgramHeader />
      <IntroSection hero={hero} />
      <CourseReasons className='mt-section-indent' />
      <EmploymentHelp />
      <CourseOutComeSection className='mt-section-indent' />
      <OneCourseTwoDiplomasSection className='mt-section-indent' />
      <AboutCourseSection className='mt-section-indent' />
      <TeachersSection className='mt-section-indent' teachers={teachers} />
      <WhyUsSection className='mt-section-indent' />
      <LeadForm1Section className='mt-section-indent' />
      <FaqSection className='mt-section-indent' />
      <LeadForm2Section className='mt-section-indent' />
      <Footer data={footer} className='mt-section-indent' />
    </div>
  )
}
